import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";

import { Button } from "../../../components/Button";
import { SHIFT_DETAILS_FOOTER_LOG_EVENT_SOURCE_UI } from "../constants";

interface CancelShiftButtonProps {
  shiftId: string;
  onCancelShift: () => void;
}

export function CancelShiftButton({ shiftId, onCancelShift }: CancelShiftButtonProps) {
  return (
    <Button
      fullWidth
      variant="outlined"
      size="large"
      sx={{
        color: (theme) => theme.palette.error.light,
        borderColor: (theme) => theme.palette.border?.primary,
      }}
      onClick={() => {
        logEvent(APP_V2_USER_EVENTS.SHIFT_DETAILS_CANCEL_SHIFT_TAPPED, {
          shiftId,
          sourceUI: SHIFT_DETAILS_FOOTER_LOG_EVENT_SOURCE_UI,
        });
        onCancelShift();
      }}
    >
      Cancel shift
    </Button>
  );
}
